export default __webpack_public_path__ + "static/media/esgIndex.3964413e.png";